import React from 'react';

function AiWork() {
  return <main>Hello world</main>;
}

export default AiWork;
